function e(e) {
	let t = 0;
	for (let n = 0; n < e.length; n++) t = (t << 5) - t + e.charCodeAt(n), t |= 0;
	return Math.abs(t);
}
function t(t) {
	if (t) return e(t) % 8;
}
function n(e) {
	if ("displayName" in e) {
		if (e.displayName) {
			let t = e.displayName.trim().split(/\s+/).filter(Boolean);
			return t.length === 0 ? "" : t.length === 1 ? t[0][0].toUpperCase() : `${t[0][0]}${t[t.length - 1][0]}`.toUpperCase();
		}
		return "";
	}
	let t = e.firstName?.trim()?.[0], n = e.lastName?.trim()?.[0];
	return t || n ? `${t ?? ""}${n ?? ""}`.toUpperCase() : "";
}
//#endregion
export { t as getAvatarColorIndex, n as getAvatarInitials };
